// extracted by mini-css-extract-plugin
export default {"switcher":"ResultAnswers_switcher__KvTjm","result":"ResultAnswers_result__3rXvn","header":"ResultAnswers_header__GVMBb"};